(()=>{
  const host=document.getElementById('MainContent');
  if(!host)return;
  const labels=()=>{
    host.querySelectorAll('.atr-rating-jump .jdgm-prev-badge').forEach(badge=>{
      const count=badge.getAttribute('data-number-of-reviews');
      badge.querySelectorAll('[role=button]').forEach(stars=>{stars.removeAttribute('role');stars.removeAttribute('tabindex');});
      const text=badge.querySelector('.jdgm-prev-badge__text');
      if(count!==null&&text&&text.textContent!==`(${count}) reviews`)text.textContent=`(${count}) reviews`;
    });
    const average=host.querySelector('#judgeme_product_reviews .jm-average-rating-display');
    const number=average?.querySelector('p.jm-text');
    if(number){
      const score=Number.parseFloat(number.textContent);
      if(Number.isFinite(score)&&!average.querySelector('.atr-review-average-stars')){
        const stars=document.createElement('span');
        stars.className='atr-review-average-stars';
        stars.textContent='★★★★★';
        stars.setAttribute('role','img');
        stars.setAttribute('aria-label',`${score} out of 5 stars`);
        stars.style.setProperty('--atr-star-fill',`${Math.max(0,Math.min(100,score*20))}%`);
        number.before(stars);
      }
    }
  };
  labels();
  const loadAlternate=event=>{
    const card=event.target.closest('[data-atr-card]');
    const image=card?.querySelector('[data-atr-alt-src]');
    if(!image)return;
    const link=image.closest('.atr-tile-image-link');
    image.addEventListener('load',()=>link?.classList.add('atr-alternate-ready'),{once:true});
    if(image.dataset.atrAltSrcset)image.srcset=image.dataset.atrAltSrcset;
    image.src=image.dataset.atrAltSrc;
    delete image.dataset.atrAltSrc;
    delete image.dataset.atrAltSrcset;
  };
  host.addEventListener('pointerover',loadAlternate,{passive:true});
  host.addEventListener('focusin',loadAlternate);
  const observer=new MutationObserver(labels);
  host.querySelectorAll('.atr-rating-jump').forEach(badge=>observer.observe(badge,{childList:true,subtree:true}));
  const reviews=host.querySelector('#judgeme_product_reviews');
  if(reviews)observer.observe(reviews,{childList:true,subtree:true});
  const video=host.querySelector('.atr-home-hero-video');
  if(video){
    const startVideo=()=>{if(!matchMedia('(min-width:750px) and (prefers-reduced-motion:no-preference)').matches||navigator.connection?.saveData)return;const begin=()=>video.play().catch(()=>{});if('requestIdleCallback' in window)requestIdleCallback(begin,{timeout:3000});else setTimeout(begin,1500);};
    if(document.readyState==='complete')startVideo();else window.addEventListener('load',startVideo,{once:true});
  }
  document.addEventListener('click',event=>{
    const rating=event.target.closest('.atr-rating-jump');
    if(!rating)return;
    const reviews=document.getElementById('judgeme_product_reviews');
    if(!reviews)return;
    event.preventDefault();
    event.stopPropagation();
    reviews.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    const heading=reviews.querySelector('[role="heading"],h2');
    if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});}
  },true);
  document.addEventListener('click',event=>{
    const pick=event.target.closest('[data-atrx-pick]');
    if(!pick)return;
    const radio=host.querySelector(`.atrx-choice input[value="${pick.dataset.atrxPick}"]`);
    if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
  });
})();
